import { Fragment, useEffect } from 'react';

import { gaTrackSignupError } from 'utils/google-analytics/gaTracking';

import Button from 'components/buttons/button';
const HandleDuplicateEmail = ({ handleClose }) => {

  useEffect(() => {
    window.posthog?.capture('View email already in use dialog');
    gaTrackSignupError('email already exists');
  }, []);

  const cancelClicked = () => {
    window.posthog?.capture('Clicks email in use dialog');
    handleClose();
  };

  return (
    <Fragment>
      <div className="error-message">
        <h5 className="title">Email Already Exists</h5>
        <hr />
        <p>
        It looks like you have already created a When I Work account with that
        email address. What would you like to do?
        </p>
        <hr />
      </div>
      <div className="error-button-group">
        <Button
          className="button button-cancel"
          type="button"
          text="Cancel"
          onClick={ cancelClicked }
        />
        <Button
          className="button button-login"
          type="link"
          href="https://login.wheniwork.com/"
          text="Go To Login"
        />
      </div>
    </Fragment>
  );
};

export default HandleDuplicateEmail;
